export default __webpack_public_path__ + "static/media/IconClose.36ce17e2.svg";